import axios from './_nestAxios'

import invaxios from './_inveAxios'

export const validarLicencia = data => axios.post('/licencias/validar-licencia', data)

export const actualizar = data => invaxios.put('/licencias', data)

export const obtener = () => invaxios.get('/licencias')

